// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h1>Path to Production for API Clients</h1>
      <h2 id="background">Background</h2>
      <p>The Lighthouse program is moving VA towards an Application Programming Interface (API) first driven digital enterprise, which will establish the next generation open management platform for Veterans and accelerate transformation in VA's core functions, such as Health, Benefits, Burial and Memorials. This platform will be a system for designing, developing, publishing, operating, monitoring, analyzing, iterating and optimizing VA’s API ecosystem.</p>
      <h2 id="overview">Overview</h2>
      <p>The VA API uses token-based authentication. Clients must provide a token with each HTTPS request. This token is issued by the VA.</p>
      <h2 id="development-api-access">Development API Access</h2>
      <p>To receive a developer token to access an API in a test environment, <a href="/apply">submit a request</a>.  If you are having trouble or have questions, email <a href="mailto:api@va.gov">api@va.gov</a> and we will get back to you quickly!</p>
      <h2 id="production-api-access">Production API Access</h2>
      <p>Once you have successfully integrated with the API and are ready to go live, you can request access to a production token by emailing <a href="mailto:api@va.gov">api@va.gov</a> and providing the information detailed below.</p>
      <h3 id="what-are-the-criteria-i-must-meet-to-be-considered-for-production-api-access%3F">What are the criteria I must meet to be considered for Production API access?</h3>
      <p>First, you must provide some basic information including:</p>
      <ul>
      <li>Your Name</li>
      <li>Email address</li>
      <li>Website</li>
      <li>Organization name</li>
      <li>Phone number</li>
      </ul>
      <p>Next, the following criteria need to be met and verified by the API team:</p>
      <ul>
      <li>You are a US-based company</li>
      <li>You agree to the <a href="/terms-of-service">Terms of Service</a></li>
      <li>The VA team is able to verify your information</li>
      <li>The VA Lighthouse team views a live demo of your application using the API in a test environment, reviews the use case and evaluates the need for API access.</li>
      </ul>
      <h3 id="what-happens-after-i-send-an-email-requesting-production-access%3F">What happens after I send an email requesting production access?</h3>
      <p>We will set up a meeting with you and the VA teams accountable for the API you want to use in production to get a demo of the application, answer technical questions about your implementation, and to ensure everyone understands the use case, implementation, and expected usage and is prepared to move forward.</p>
      <h3 id="what-happens-after-i-am-approved%3F">What happens after I am approved?</h3>
      <p>You will receive an email from the VA API team notifying you of approval. You will then receive a new Client ID and Secret for your app in production. You will use the base URL <code>api.va.gov</code> instead of <code>dev-api.va.gov</code>.</p>
      <h2 id="developer-guidelines">Developer Guidelines</h2>
      <p>Below are guidelines you should follow to be successful in your VA API integration.</p>
      <h3 id="your-privacy-policy">Your Privacy Policy</h3>
      <p>If you are a team external to VA, you will be asked to provide a URL to your privacy policy and terms and conditions when applying for production access. These links should be easy to access and understand by a Veteran using your application.</p>
      <h3 id="rate-limiting-and-data-refresh">Rate Limiting and Data Refresh</h3>
      <p>We implemented basic rate limiting of 60 requests per minute. If you exceed this quota, your request will return a 429 status code.  You may petition for increased rate limits by emailing <a href="mailto:api@va.gov">api@va.gov</a> and requests will be decided on a case by case basis.</p>
    </div>
  );
};

export default MarkdownComponent;
